export default {
	CHANGE:(state,item)=>{
		state.change = item
	},
  CLASSIFY:(state,item)=>{
	  state.classifyId = item
  },
  HEADERNAME:(state,item)=>{
	  state.headerName = item
  },
  CVU:(state,item)=>{
	  state.courseVideUrl = item
  },
  WXUSERINFO:(state,item)=>{
    state.wxUserInfo = item
    if(item.phone){
      state.isLogin = true
    }
  },
  ISLOGIN:(state,item)=>{
    state.isLogin = item
  },
  FLOWERCOUNT:(state,item)=>{
    state.flowerCount = item
  },
  SHOWCOVER:(state,item)=>{
    if(typeof item == 'object'){
      state.popup = item
    }else{
      state.popup.show = item
    }
  },
	SETREVICE:(state,item)=>{
		state.hasUserRevice = item
	}
}



// WEBPACK FOOTER //
// ./src/store/mutations.js